import { render, staticRenderFns } from "./user-basic.vue?vue&type=template&id=ae50a652&"
import script from "./user-basic.vue?vue&type=script&lang=ts&"
export * from "./user-basic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports